import React from "react";
import * as Styled from "./styles";
import { ASSETS } from "../../../utils/config";
import { Stack } from "@mui/material";
import TextView from "../../TextView";

function SidePaneWrapper({
  isVisible = false,
  children,
  handleDelete,
  handleDuplicate,
  title,
  icon,
}) {
  return (
    <Styled.WrapperMainDiv isVisible={isVisible}>
      <div style={{ height: 40 }}>
        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          direction={"row"}
        >
          <Stack direction={"row"}>
            <img src={icon} alt="ws" style={{ marginRight: 10 }} />
            <TextView variant="title" style={{ height: "100%" }}>
              {title}
            </TextView>
          </Stack>
          <Stack flexDirection={"row"}>
            <div onClick={handleDuplicate} style={{ cursor: "pointer" }}>
              <img
                src={ASSETS.segmentEditor.CopyIcon}
                alt="Clone Icon"
                width={24}
                height={24}
              />
            </div>
            <div onClick={handleDelete} style={{ cursor: "pointer" }}>
              <img
                src={ASSETS.segmentEditor.DeleteIcon}
                alt="ws"
                style={{ marginRight: 5 }}
              />
            </div>
          </Stack>
        </Stack>
      </div>
      <div style={{ overflowY: "auto", height:"calc(92vh)", maxHeight: "calc(92vh - 80px)" }}>
        {children}
      </div>
    </Styled.WrapperMainDiv>
  );
}

export default SidePaneWrapper;
